import { Component, OnDestroy, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router, Event, NavigationStart, NavigationEnd, RouterLink, RouterLinkActive } from '@angular/router';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NgClass, AsyncPipe } from '@angular/common';
import { ImgSrcSetDirective } from '../../directives/img-src-set.directive';

@Component({
    selector: 'app-shop-menu',
    templateUrl: './shop-menu.component.html',
    styleUrls: ['./shop-menu.component.scss'],
    imports: [NgClass, RouterLink, RouterLinkActive, ImgSrcSetDirective, AsyncPipe]
})
export class ShopMenuComponent implements OnDestroy {
  auth = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  shoppingCartService = inject(ShoppingCartService);


  menuShown = false;
  shopping = false;
  subscription: Subscription;

  firstPromotedItem = {
    safeProductUrl: '/product/14ct-yellow-gold-knot-wedding-ring-rfgd031ynn',
    originalImageUrl: `${environment.image.root}RFGD031YNN.jpg`,
    safeImageUrl: `${environment.image.root}RFGD031YNN.jpg?tr=w-100,h-100`,
    title: '14ct yellow gold knot wedding ring'
  };

  secondPromotedItem = {
    safeProductUrl: '/product/house-of-lor-silverrose-gold-cz-huggie-earrings-1-bar-on-each-made-from-rare-irish-gold-h30002',
    originalImageUrl: `${environment.image.root}H30002.jpg`,
    safeImageUrl: `${environment.image.root}H30002.jpg?tr=w-100,h-100`,
    title: 'House of Lor silver/rose gold cz huggie earrings 1 bar on each made from rare Irish gold'
  };

  constructor() {
    const router = this.router;

    this.subscription = router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.menuShown = false;
      }
      if (event instanceof NavigationEnd) {
        this.shopping = event.url.includes('/product') || event.url.includes('/collection');
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
